





































































import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import {
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError,
} from '@/mixins';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  confirmBeforeClose: boolean;
  coverageTier: any;
  orderArray: string[];
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError,
).extend({
  name: 'UpdateCoverageTier',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      confirmBeforeClose: true,
      coverageTier: null,
      orderArray: [
        'PremiumSaver',
        'BasicSaver',
        'ThriftSaver',
        'SelectSaver',
        'FreeSaver',
      ],
    };
  },
  beforeMount() {
    this.showErrorModel.coverageTier = false;
  },
  validations: {
    coverageTier: {
      required,
    },
  },
  computed: {
    coverageTierOptions(): string[] {
      return ['Single', 'Family'];
    },

    // VALIDATIONS
    coverageTierErrors(): string[] {
      const formField = 'coverageTier';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-coverage-tier_form-error_coverage-tier_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
  },
  methods: {
    tryAgain(): void {
      this.showErrorMessage = false;
      this.confirmBeforeClose = true;
    },
    updateCoverageTier(): void {
      this.isLoading = true;
      this.$store
        .dispatch('updateAccountTier', {
          accountId: this.params.accountId,
          coverageTier: this.coverageTier,
        })
        .then(() => {
          this.refreshAccounts();
        })
        .catch(() => {
          this.confirmBeforeClose = false;
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshAccounts(): void {
      this.$store
        .dispatch('getAccounts')
        .then(() => {
          this.confirmBeforeClose = false;
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'update-coverage-tier_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
